<template>
  <nav>
    <div class="menu navbar-collapse" id="navbarNav">
      <div class="radio">
        <label
          v-for="(category, index) in categoriesS"
          :key="index"
          class="nav-link text-center nav-item"
          style="font-weight: 700;"
        >
          <input
            type="radio"
            name="categoryS"
            :value="category.id"
            v-model="selectedCategorySId"
            @change="changeCategoryS(category)"
          />
          {{ category.name }}
        </label>
      </div>
    </div>
    <div class="navbar navbar-expand-lg">
      <div class="menu navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item with-border">
            <a
              class="nav-link text-center"
              href="#"
              @click.prevent="selectAllProducts"
              :class="{ active: currentCategoryA === null }"
            >
              Todos
            </a>
          </li>
          <li
            v-for="(subcategory, index) in filteredSubcategories"
            :key="index"
            class="with-border nav-item"
            :class="{ active: isCurrentCategoryA(subcategory) }"
          >
            <a
              class="nav-link text-center"
              href="#"
              @click.prevent="changeCategoryA(subcategory)"
            >
              <font-awesome-icon :icon="subcategory.icon" />
              {{ subcategory.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "ProductsMenu",
    data() {
      return {
        selectedCategorySId: null, // ID da categoria S selecionada
      };
    },
    computed: {
      ...mapGetters({
        getCategories: "getCategories",
        getProducts: "getProducts",
        currentCategoryS: "getCurrentCategory",
        currentCategoryA: "getCurrentCategoryA",
      }),
      categoriesS() {
        return this.getCategories.filter((category) => category.type === "S");
      },
      filteredSubcategories() {
        if (!this.currentCategoryS) {
          return [];
        }
        return this.getCategories.filter(
          (subcategory) =>
            subcategory.type === "A" &&
            subcategory.parent_id === this.currentCategoryS.id
        );
      },
    },
    watch: {
      selectedCategorySId(newVal) {
        const category = this.categoriesS.find((cat) => cat.id === newVal);
        if (category) this.changeCategoryS(category);
      },
    },
    methods: {
      ...mapActions({
        changeCurrentCategoryS: "changeCurrentCategoryS",
        changeCurrentCategoryA: "changeCurrentCategoryA",
      }),
      isCurrentCategoryS(category) {
        return (
          this.currentCategoryS && category.id === this.currentCategoryS.id
        );
      },
      isCurrentCategoryA(subcategory) {
        return (
          this.currentCategoryA &&
          subcategory &&
          subcategory.id === this.currentCategoryA.id
        );
      },
      changeCategoryS(category) {
        this.changeCurrentCategoryS(category);
        this.selectedCategorySId = category.id;
        this.selectAllProducts(); // Selecione 'Todos' ao mudar de categoria
      },
      changeCategoryA(subcategory) {
        this.changeCurrentCategoryA(subcategory);
      },
      selectAllProducts() {
        this.changeCurrentCategoryA(null);
        this.changeCurrentCategoryS(this.currentCategoryS);
      },
    },
    mounted() {
      if (this.categoriesS.length > 0) {
        // Seleciona a primeira categoria S e 'Todos' por padrão
        const firstCategory = this.categoriesS[0];
        this.changeCategoryS(firstCategory);
        this.selectAllProducts();
      }
    },
  };
</script>

<style>
  .navbar {
    display: flex;
    flex-direction: column;
    flex-flow: wrap;
  }

  .navbar-nav {
    margin: auto;
  }

  .with-border {
    border-right: 1px solid #ffffff;
  }

  .menu ul li a {
    color: #fff;
    font-weight: bold;
    font-size: 15px;
  }

  .navbar {
    background-color: var(--dark-orange);
  }

  .nav-link i {
    color: var(--light-orange);
    font-size: 21px;
  }

  .nav-link {
    margin-left: 19px;
    margin-right: 19px;
  }

  .active {
    background-image: url("./../../assets/images/orange-splash.png");
    -webkit-background-size: cover;
    -moz-background-size: center cover;
    background-size: cover;
    background-position: center top;
  }

  .active a i {
    color: var(--dark-orange);
  }

  .radio {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
  }

  .radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 15px;
  }

  .radio-group label {
    display: flex;
    align-items: center;
    margin-right: 10px;
    padding: 5px;
    border: 1px solid transparent;
    cursor: pointer;
  }

  .radio-group label.active {
    border-color: var(--light-orange);
    background-color: var(--light-orange);
  }

  .radio-group input[type="radio"] {
    display: none;
  }

  .radio-group input[type="radio"]:checked + font-awesome-icon {
    color: var(--dark-orange);
  }
</style>
